import { Button, Input, Select, Switch } from "antd";
import { TableProps } from "antd/es/table";
import { useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import FilterIcon from "../../../assets/icons/FilterIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import CustomTable from "../../../components/ui/CustomTable";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { selectSearchOption, selectStringOption } from "../../../utils/utils";

export default function Stories() {
  const { page, limit, handlePagination, handleLimit } = useTable();
  const [switchStatus, setSwitchStatus] = useState(false);

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Leave Type",
      dataIndex: "type",
      width: 351,
      // render: (val) => <span>{val.length > 42 ? val.slice(0, 42) : val}</span>,
    },

    {
      title: "Published",
      dataIndex: "published",
    },

    {
      title: "Last Updated",
      dataIndex: "date",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 116,
      render: (value) => (
        <div className="flex gap-x-1">
          <Switch size="small" onChange={(val) => setSwitchStatus(val)} />
          <span className="">{switchStatus ? "Active" : "Inactive"}</span>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Button
            className="action-button"
            size="small"
            icon={<EditIcon />}
            // onClick={() =>
            //   handleOpen({
            //     type: "UPDATE",
            //     data: val,
            //   })
            // }
          />

          <Button className="action-button" size="small" icon={<ViewIcon />} />
        </div>
      ),
    },
  ];

  return (
    <SidebarLayout title="Website CMS - Stories">
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={120} // Update total as per the data
        dataSource={data}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ width: 220 }}
            />

            <Select
              allowClear
              showSearch
              placeholder="Filter"
              filterOption={selectSearchOption}
              // options={selectStringOption([
              //   "IT",
              //   "Design",
              //   "Development",
              //   "Mobile App",
              // ])}
              className="min-w-[130px]"
              suffixIcon={<FilterIcon />}
              rootClassName="icon-gray"
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectStringOption(["Published", "Draft", "Archived"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />

            <Link to={`/admin/stories/add-stories`}>
              <Button
                type="primary"
                className="middle-button"
                icon={<AddIcon />}
              >
                Add New
              </Button>
            </Link>
          </>
        }
      />
    </SidebarLayout>
  );
}

interface DataType {
  type: string;
  published: string;
  date: string;
  status: string;
  id: string;
}

const data: DataType[] = [
  {
    type: "Integrating Automation in Employee Expense tracking to save time and cut cost",
    published: "10 Jan, 2024 09:35 AM",

    date: "10 Jan, 2025",
    status: "Published",
    id: "1",
  },
  {
    type: "Integrating Automation in Employee Expense tracking to save time and cut cost",
    published: "10 Jan, 2024 09:35 AM",
    date: "10 Jan, 2025",
    status: "Archived",
    id: "2",
  },
  {
    type: "Integrating Automation in Employee Expense tracking to save time and cut cost",
    published: "10 Jan, 2024 09:35 AM",
    date: "10 Jan, 2025",
    status: "Draft",
    id: "3",
  },
];
